import React from "react";
import Dialog from "rc-dialog";
import Aperture from "@/components/Aperture";
import useIsomorphicLayoutEffect from "@/hooks/useIsomorphicLayoutEffect";
import Overlay from "@/components/overlay/Overlay";

interface Props {
	visible: boolean;
	onClose: () => void;
	zIndex?: number;
	children: React.ReactNode;
	bgLevel?: "normal" | "deep";
	apertureTop?: string;
}
export default function CustomerModal(props: Props) {
	useIsomorphicLayoutEffect(() => {
		const firstChild = document.querySelector("#__next > :first-child");
		if (props.visible) {
			firstChild?.classList.add("filter__bg");
		} else {
			if (typeof window !== "undefined") {
				firstChild?.classList.remove("filter__bg");
			}
		}
	}, [props.visible]);

	return (
		<>
			<Overlay bgLevel={props.bgLevel} visible={props.visible} onClose={props.onClose}>
				<Aperture
					style={{
						top: props.apertureTop ?? "53%",
					}}
				/>
			</Overlay>

			<Dialog
				visible={props.visible}
				onClose={props.onClose}
				closable={false}
				prefixCls="rf-modal"
				transitionName="rf-zoom"
				maskTransitionName="rf-fade"
				mask={false}
				zIndex={props.zIndex || 1000}
			>
				{props.children}
			</Dialog>
		</>
	);
}
